<div class="flex flex-wrap gap-4">
  <div class="flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <app-task-data-target (click)="navigateToMemberProfile()">
      <mat-icon icon>account_circle</mat-icon>
      <span text>{{ task.data.memberName }}</span>
    </app-task-data-target>
    <p>{{ task.data.memberPhoneNumber }}</p>
  </div>
  <div class="flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <div class="flex gap-2 text-lg">
      <mat-icon>corporate_fare</mat-icon>
      {{ task.data.partnerName }}
    </div>
    @if (task.data.partnerName !== task.data.locationName) {
      <p>{{ task.data.locationName }}</p>
    }
    <p>{{ task.data.locationAddress }}</p>
    @if (task.data.partnerPhoneNumbers.length) {
      <div class="flex flex-col gap-1">
        @for (phone of task.data.partnerPhoneNumbers; track phone) {
          <p>{{ phone }}</p>
        }
      </div>
    }
  </div>
  <div class="relative flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <app-task-data-target (click)="navigateToAppointment()">
      <mat-icon
        icon
        svgIcon="doctor"
      />
      <span text>{{ task.data.serviceName }}</span>
    </app-task-data-target>
    <p>{{ task.data.doctorName }}</p>
    @if (task.data.appointmentStartDate) {
      <p>{{ formatDate(task.data.appointmentStartDate, true) }}</p>
    }
  </div>
  <div class="relative flex shrink grow basis-96 flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <div class="flex items-center justify-between">
      @if (task.status !== taskStatus.Resolved) {
        <h4>{{ task.description }} {{ "task.message.updateAppointmentStatus" | translate }}</h4>
      } @else {
        <h4>{{ "task.message.appointmentStatusUpdated" | translate }}</h4>
      }
      @if (errorMessage()) {
        <span class="text-sm text-error-500">{{ errorMessage() }}</span>
      }
    </div>

    <prescriptions-appointment-status-control
      [formControl]="statusFc"
      [originalStatus]="planningDetails()?.status"
    ></prescriptions-appointment-status-control>

    <mat-form-field class="w-full">
      <mat-label>{{ "appointments.headings.notes" | translate }}</mat-label>
      <textarea
        matInput
        [formControl]="noteFc"
        [readonly]="task.status === taskStatus.Resolved"
        rows="4"
      ></textarea>
    </mat-form-field>

    @if (task.status !== taskStatus.Resolved) {
      <div class="flex justify-end">
        <button
          class="btn btn-primary"
          type="button"
          [disabled]="loading() || !isStatusChanged()"
          (click)="submit()"
        >
          {{ "task.action.resolve" | translate }}
        </button>
      </div>
    }

    @if (loading()) {
      <div class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/80">
        <shared-loader />
      </div>
    }
  </div>
</div>
